import Shepherd from "shepherd.js";
import { useEffect } from "react";

const createTour = () => {
  const tour = new Shepherd.Tour({
    defaultStepOptions: {
      classes: "shepherd-theme-arrows",
      scrollTo: true,
      // cancelIcon: {
      //   enabled: true,
      // },
    },
    useModalOverlay: true,
  });
  tour.steps = [];
  return tour;
};

export const initialPageScreen = `<div
    style="display:flex; flex-direction:column ; gap: 10px ; justify-content:center; place-items: center"
  >
    <img src="https://d9hhrg4mnvzow.cloudfront.net/discover.agilysys.com/sem/versa-pms/a2f817a3-agilysys-versa-color_108402u08002u002000028.png" width="100px" height="50px"/>
    <h3>Welcome to Versa Onboarding Tool</h3>  
  <div>`;

export const DashboardTour = () => {
  const tour = createTour();
  useEffect(() => {
    tour.addStep({
      id: "welcome",
      text: initialPageScreen,
      buttons: [
        {
          text: "Next",
          action: tour.next,
        },
      ],
    });

    tour.addStep({
      id: "googleAutoCompleteField",
      text: "Enter the address to autofill fields",
      attachTo: { element: ".googleAutoCompleteField", on: "bottom" },
      buttons: [
        {
          text: "Back",
          action: tour.back,
        },
        {
          text: "complete",
          action: () => {
            localStorage.setItem("isTourCompleted", "true");
            tour.complete();
          },
        },
      ],
    });

    tour.start();
  }, []);
};

export const TaxExempt = () => {
  const tour = createTour();
  useEffect(() => {
    tour.addStep({
      id: "TaxExemptCode",
      text: "Enter the tax Exempt Code",
      attachTo: { element: ".taxExemptCode", on: "bottom" },
      buttons: [
        {
          text: "Next",
          action: tour.next,
        },
      ],
    });

    tour.addStep({
      id: "defaultFields",
      text: "We already have default values setup",
      attachTo: { element: ".dndFields", on: "bottom" },
      buttons: [
        {
          text: "Back",
          action: tour.back,
        },
        {
          text: "complete",
          action: () => {
            localStorage.setItem("isTourCompleted", "true");
            tour.complete();
          },
        },
      ],
    });

    tour.start();
  }, []);
};
